import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './MovuRobotics.frontend.types'

@Injectable({ providedIn: 'root' })
export class MovuRobotics_map_alter_pallet_hold_release_request_payloadService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { taskId: number, storageTransactionId?: string }): Promise<{ outputDetails?: string[], outputMapResult?: $frontendTypes.MovuRobotics.HoldReleasePalletRequests }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.taskId)) {
      $missingRequiredInParams.push('\'taskId\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

